export enum PspCompany {
  Mollie = "Mollie",
  Adyen = "Adyen",
}

export interface MollieCardComponentResult {
  token?: string;
  error?: {
    detail?: string;
    message?: string;
    statusCode?: string;
  };
}
